import { render, staticRenderFns } from "./ScoreStampPreviewSidebar.vue?vue&type=template&id=cd7484b2&scoped=true&"
import script from "./ScoreStampPreviewSidebar.vue?vue&type=script&lang=ts&"
export * from "./ScoreStampPreviewSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreStampPreviewSidebar.vue?vue&type=style&index=0&id=cd7484b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7484b2",
  null
  
)

export default component.exports